const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Question",
    dataIndex: "question",
    render: (_, record) => (record?.field_label ? record?.field_label : "--"),
  },
  {
    title: "Answer",
    dataIndex: "response_text",
    render: defaultRender,
    width: 250,
    fixed: "right",
  },
];

export default columns;
